import request from "@src/utils/request";

export function validateOAuthCode(code: string, state?: string | null) {
  const payload: { code: string; state?: string } = { code };
  if (state) {
    payload.state = state;
  }
  return request().post("/api/v1/validate-covetrus-oauth-code/").send(payload);
}
